export const isDev = process.env.NODE_ENV === 'development';

export const getParameterByName = (name) => {
	var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
	return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
};

export const getWidgetContainer = () =>
	document.querySelector('.header-brandbar__search');

export const openMobileBar = () => {
	const container = getWidgetContainer();
	if (!container) return;

	container.classList.remove('hideTop');
};

export const closeMobileBar = () => {
	const container = getWidgetContainer();
	if (!container) return;

	container.classList.add('hideTop');

	const searchIcon = document.querySelector('.header-service__search-mobile');
	if (!searchIcon) return;

	searchIcon.focus();
};

export const decodeHTML = (html) => {
	const txt = document.createElement('textarea');
	txt.innerHTML = html;
	return txt.value;
};

export const buildSiteUrl = (env, clientCode) => {
	if (env === 'production' || env === 'local') {
		if (clientCode.toUpperCase() === 'AOL') return 'https://ao.com';
		if (clientCode.toUpperCase() === 'ADE') return 'https://www.ao.de';
		if (clientCode.toUpperCase() === 'TUK')
			return 'https://www.ao-business.com';
	}

	return `https://${env.toLowerCase()}-${clientCode.toLowerCase()}.ao-qa.com`;
};

export const getCurrentEnv = (host) => {
	host = !host ? window.location.host : host;

	// Production
	if (
		host.includes('ao.com') ||
		host.includes('ao.de') ||
		host.includes('ao-business.com')
	)
		return 'production';

	// Beta
	if (host.includes('beta-')) return 'beta';

	// Staging
	if (host.includes('staging-')) return 'staging';

	// Dev
	if (host.includes('dev-')) return 'dev';

	return 'local';
};

export const getCurrentEnvForSearch = () => {
	const host = window.location.host;

	// Production
	if (
		host.includes('ao.com') ||
		host.includes('ao.de') ||
		host.includes('ao-business.com')
	)
		return 'live';

	// Staging
	if (host.includes('staging-')) return 'staging';

	return 'beta';
};

export const getCurrentSiteUrl = (clientCode) => {
	const siteUrl = buildSiteUrl(getCurrentEnv(), clientCode);

	return siteUrl;
};

export const getClientObj = (client) => {
	const siteUrl = {
		production: buildSiteUrl('production', client),
		staging: buildSiteUrl('staging', client),
		beta: buildSiteUrl('beta', client),
		dev: buildSiteUrl('dev', client),
	};

	if (client.toUpperCase() === 'AOL' || client.toUpperCase() === 'TUK') {
		const searchParamKey = 'search';

		return {
			searchParamKey,
			siteUrl,
		};
	}

	if (client.toUpperCase() === 'ADE') {
		const searchParamKey = 'suche';

		return {
			searchParamKey,
			siteUrl,
		};
	}
};

export const getSearchApiUrl = (searchTerm, clientCode = 'AOL') => {
	const clientId = getClientIdFromClientCode(clientCode);

	const urlSuffix = `?search=${encodeURIComponent(
		searchTerm
	)}&clientid=${clientId}`;
	const currentEnv = getCurrentEnvForSearch();

	if (isDev) {
		return `https://beta-predictivesearch.megaweb.ao.com/${urlSuffix}`;
	}

	return `https://${currentEnv}-predictivesearch.megaweb.ao.com/${urlSuffix}`;
};

const getClientIdFromClientCode = (clientCode) => {
	const clientMap = { AOL: 1, ADE: 44, TUK: 53, BTS: 8 };

	if (Object.prototype.hasOwnProperty.call(clientMap, clientCode) === false) {
		throw new Error(`Couldn't get clientId from ${clientCode}`);
	}
	return clientMap[clientCode.toUpperCase()];
};

export const getClientByDomain = (domain) => {
	const hostname = !domain ? window.location.hostname : domain;
	let client = 'AOL';

	if (hostname.includes('ao.com') || hostname.includes('-aol')) client = 'AOL';
	if (hostname.includes('ao.de') || hostname.includes('-ade')) client = 'ADE';
	if (hostname.includes('ao-business.com') || hostname.includes('-tuk'))
		client = 'TUK';

	if (hostname.includes('beta-reviews')) {
		if (window.location.search.includes('clientId=1')) client = 'AOL';
		if (window.location.search.includes('clientId=44')) client = 'ADE';
		if (window.location.search.includes('clientId=53')) client = 'TUK';
	}

	if (hostname.includes('localhost')) {
		if (window.location.search.includes('client=aol')) client = 'AOL';
		if (window.location.search.includes('client=ade')) client = 'ADE';
		if (window.location.search.includes('client=tuk')) client = 'TUK';
	}

	return client;
};

export const getPresetInputValue = () => {
	if (
		window &&
		window.AOSearchWidget &&
		window.AOSearchWidget.presetInputValue
	) {
		return window.AOSearchWidget.presetInputValue;
	}

	return '';
};

export const getSearchUrl = (searchKey, searchValue) => {
	return `/l/${searchKey}/101/99/?${searchKey}=${encodeURIComponent(
		searchValue
	)}`;
};

export const submitTermSearch = (clientCode, searchValue) => {
	const client = getClientObj(clientCode);
	window.location.href = `${getCurrentSiteUrl(clientCode)}${getSearchUrl(
		client.searchParamKey,
		searchValue
	)}`;
};
